import { Link } from "react-router-dom";
import { products } from "../products";
import Seo from "../components/Seo";

export default function About() {
  return (
    <section className="about">
      <Seo
        title="About"
        description="OLYMPUS MEDS — pharmaceutical-grade formulations engineered in Berlin. EU-sourced actives, sterile manufacturing, and a transparent reference catalog."
        path="/about"
      />
      <div className="about__hero">
        <div className="about__hero-inner">
          <span className="eyebrow">About</span>
          <h1 className="about__title">
            A pharmaceutical <br />
            standard, <br />
            <span className="about__title-gold">without compromise.</span>
          </h1>
          <p className="about__lede">
            OLYMPUS MEDS was built on a simple conviction — that pharmaceutical-grade means pharmaceutical-grade.
            No compromises. No substitutes. No secrets.
          </p>
        </div>
      </div>

      <div className="about__body">
        <div className="about__chapter">
          <div className="about__chapter-num">01</div>
          <div className="about__chapter-text">
            <h2>Origin — Berlin</h2>
            <p>
              We operate from Berlin, Germany — a city whose pharmaceutical tradition stretches back two centuries.
              Our active substances are sourced exclusively from European Union suppliers, assayed against the United
              States Pharmacopeia reference standards, and never blended with materials of unknown provenance.
            </p>
            <p>
              Every batch begins with a certificate of analysis. Every finished product ends with one.
            </p>
          </div>
        </div>

        <div className="about__chapter">
          <div className="about__chapter-num">02</div>
          <div className="about__chapter-text">
            <h2>Craft — Sterile by design</h2>
            <p>
              Injectable formulations are prepared in pharmaceutical-grade MCT oil, with benzyl alcohol and benzyl
              benzoate as co-solvents — a carrier system used in licensed European testosterone and nandrolone
              products. Oral formulations are compressed or encapsulated under controlled humidity, then sealed in
              blister packaging that protects the active from light and moisture.
            </p>
            <p>
              Every step is validated. Every gram is weighed. Every mL is accounted for.
            </p>
          </div>
        </div>

        <div className="about__chapter">
          <div className="about__chapter-num">03</div>
          <div className="about__chapter-text">
            <h2>Transparency — A reference, not a pitch</h2>
            <p>
              This website is a product showcase. You will find no price list, no shopping cart, no marketing
              superlatives. What you will find is the pharmaceutical name of each compound, its molecular formula,
              its mechanism of action, and its documented therapeutic indications — presented plainly, the way a
              reference catalog should present them.
            </p>
            <p>
              We believe the most honest way to speak about a medication is to tell the truth about what it is.
            </p>
          </div>
        </div>

        <div className="about__chapter">
          <div className="about__chapter-num">04</div>
          <div className="about__chapter-text">
            <h2>The Catalog</h2>
            <p>
              Our catalog comprises {products.length} distinct formulations across three families —{" "}
              <strong>injectable esters</strong>, <strong>oral derivatives</strong>, and{" "}
              <strong>master blends</strong>. Each is held to the same pharmaceutical-grade standard.
            </p>
            <p>
              <Link to="/catalog" className="about__link">
                View the complete catalog →
              </Link>
            </p>
          </div>
        </div>
      </div>

      <div className="about__coda">
        <div className="about__coda-inner">
          <div className="about__coda-text">
            <div className="about__coda-title">OLYMPUS MEDS</div>
            <div className="about__coda-sub">Pharmaceutical-grade formulations · Berlin, Germany</div>
          </div>
        </div>
      </div>
    </section>
  );
}
